import { render, staticRenderFns } from "./ticket-orders.vue?vue&type=template&id=6f9cdd56"
import script from "./ticket-orders.vue?vue&type=script&lang=js"
export * from "./ticket-orders.vue?vue&type=script&lang=js"
import style0 from "./ticket-orders.vue?vue&type=style&index=0&id=6f9cdd56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports